export const fallbackImg = '/images/fallback.jpg'
export const emptyBoxImg = '/images/create/empty-box.png'
